import useStyles from './style';
import { useTranslation } from 'react-i18next';

const Watchdogs: React.FunctionComponent = () => {

  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <div className={classes.row}>
        <p className={classes.text}>
          {t('watchdogs_info')}  
        </p>
      </div>
      <div className={classes.row}>
        <div className={classes.fullblock}>
          <span className={classes.title}>
            {t('watchdogs_rules')}
          </span>
          <div className={classes.text}>
            {t('watchdogs_rules_description')}
            <ul>
              <li>{t('substitutions_rules_date_past')}</li>
              <li>{t('substitutions_rules_schools_enabled')}</li>
              <li>{t('substitutions_rules_schools_workdays')}</li>
              <li>{t('substitutions_rules_schools_holidays')}</li>
              <li>{t('substitutions_rules_children_attendance')}</li>
              <li>{t('substitutions_rules_children_excuse_notes')}</li>
              <li>{t('substitutions_rules_children_substitutions')}</li>
              <li>{t('substitutions_rules_children_watchdogs')}</li>
              <li>{t('substitutions_rules_children_attendance_full_day')}</li>
              <li>{t('substitutions_rules_children_credit')}</li>
            </ul>  
          </div>
        </div>
      </div>
    </>
  );
};

export default Watchdogs;